export default [
  {
    path: '/management_control',
    name: 'ManagementControl',
    component: () => import('@/views/ManagementControl/ManagementControl.vue'),
    meta: {
      prev: 'goHome',
      header: 'management'
    }
  }
]
